import { ChangeDetectorRef, Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Constants } from '../../../../../core/services/constants.service';
import { Router } from '@angular/router';
import { HttpService } from '../../../../../core';
import { environment } from "../../../../../../environments/environment";
import { AllocateDialogComponent } from "../allocate-dialog/allocate-dialog.component";


@Component({
    selector: 'app-property-detail-dialog',
    templateUrl: './property-detail-dialog.component.html',
    styleUrls: ['./property-detail-dialog.component.scss']
})
export class PropertyDetailDialogComponent implements OnInit {

    property: any;
    project: any;
    building: any;
    imageUrl: any;
    SERVER_URL = environment.SERVER_URL;
    constants = Constants;

    onClickImage = new EventEmitter();
    editProperty = new EventEmitter();


    agencyList: [];
    bindAgencyList: [];
    selectedProperties: [];
    agencyIds: number[] = [];

    getExternalArea = (property) =>{
        return property.externalAreas?(Number(property.externalAreas.externalArea1)+Number(property.externalAreas.externalArea2)):0
     }

    constructor(
        private dialog: MatDialog,
        private httpService: HttpService,
        private router: Router,
        private cdr: ChangeDetectorRef,
        private dialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    }

    ngOnInit(): void {
        this.property = this.data.property;
        console.log(this.property,'property')
        // property 所属的 building
        this.building = this.property.project;

        // building 的 project
        this.project = this.data.project;

        let image = (this.property.floorPlan && this.property.floorPlan.images.length) ? this.property.floorPlan.images[0] : null;

        this.imageUrl = image ? this.SERVER_URL + 'images/' + this.project.projectCode + '/floor_plans/' + image.fileName : null

        // 获取project的中介
        this.httpService.getAgencyList(this.project.id).toPromise().then((agencyList: any) => {
            this.agencyList = agencyList.data
        })
        this.getBindAgency()
    }
   

    getBindAgency() {
        this.agencyIds = [];
        // 获取已经绑定的中介
        this.httpService.getBindAgencyList(this.property.id).toPromise().then((bindAgencyList: any) => {
            this.bindAgencyList = bindAgencyList.data
            this.bindAgencyList.map((agency: any) => {
                this.agencyIds.push(agency.id)
            })
        })
    }

    editAllocation() {
        const item: any[] = []
        item.push(this.property)
        this.getBindAgency()
        const dialogRef = this.dialog.open(AllocateDialogComponent, {
            width: '416px',
            data: { project: this.project, selectedProperties: item, agencyIds: this.agencyIds, isAloneProperty: true },
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            this.getBindAgency()
        });

    }

    cancel() {
        this.dialogRef.close();
    }

    openImagePreviewDialog() {
        this.onClickImage.emit({ property: this.property })
    }

    editPropertyClick() {
        this.cancel();
        this.editProperty.emit();
    }

    getStatusLabel(status) {
        switch (status) {
            case 0:
                return 'unavailable';
            case 1:
                return 'available';
            case 2:
                return 'reserved'; // eoi
            case 3:
                return 'reserved';
            case 4:
                return 'processing';  //exchanage conditional
            case 5:
                return 'processing'; // unconditional
            case 6:
                return 'sold';
        }
    }

    transformLevel(level) {
        switch (level) {
            case -1:
                return 'GC';
            case -2:
                return 'GB';
            case -3:
                return 'GA';
            case -4:
                return 'G';
            case -5:
                return 'LG';
            case -6:
                return 'L';
            case -7:
                return 'B';
            case -8:
                return 'B1';
            case -9:
                return 'B2';
            case -10:
                return 'B3';
            case -11:
                return 'B4';
            case -12:
                return 'B5';
            default:
                return level;
        }
    }
}
